module.exports = "/_next/static/images/Integration@2x-7fba211fef67320d808fcc59c8f6f98f.png";